import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {NO_ACCESS_TEXT} from 'processes/ProcessConstants';
import {AssigneeAvatar} from 'processes/tables/ProcessTaskAssigneeAvatar';
import {HasAvatar} from 'ui-library/avatar/Avatar';
import PartyList from 'ui-library/PartyList';

import {InaccessibleInfoGraphQL} from '../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

export interface RequestV2AssigneeInfo {
  __typename: 'RequestV2SubmissionAssigneeNode';
  totalNumberOfAssignees: number;
  firstAssignees: Array<HasAvatar & {name: string}>;
}

interface RequestV2AssigneeDisplayProps {
  assigneeInfo: RequestV2AssigneeInfo | InaccessibleInfoGraphQL;
}

export default function RequestV2AssigneeDisplay(props: RequestV2AssigneeDisplayProps): JSX.Element {
  if (isInaccessible(props.assigneeInfo)) {
    return <>{NO_ACCESS_TEXT}</>;
  }

  if (props.assigneeInfo.totalNumberOfAssignees === 0) {
    return <AssigneeAvatar party={{name: 'Unassigned'}} useNoAvatar={true} />;
  }

  const extraPartiesContent = (
    <>
      {props.assigneeInfo.firstAssignees.map((assignee) => assignee.name).join(', ')}
      {props.assigneeInfo.firstAssignees.length < props.assigneeInfo.totalNumberOfAssignees ? '...' : ''}
    </>
  );

  return (
    <PartyList
      parties={props.assigneeInfo.firstAssignees}
      maxParties={1}
      totalNumberOfParties={props.assigneeInfo.totalNumberOfAssignees}
      useAvatar={true}
      popoverOverride={extraPartiesContent}
    />
  );
}
